module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', [_c('el-table', {
    attrs: {
      "data": _vm.list,
      "width": "100%",
      "height": "420",
      "highlight-current-row": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "id",
      "label": "ID",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "title",
      "label": "标题名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "links",
      "label": "链接"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pager",
    attrs: {
      "page-size": _vm.params.pageSize,
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0e81a124", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e81a124"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_links/comps/link.vue
// module id = 2466
// module chunks = 0